<div class="wrapper" id="date-picker-wrapper" (click)="$event.stopPropagation()">
  <p *ngIf="isBillingTab" class="date-note">
    You should make new date selection after switching billing and usage date.
  </p>
  <form [formGroup]="datesForm" class="date-controls" *ngIf="!showMonthsOnly">
    <div *ngIf="isBillingTab" class="cur-date-filter">
      <mat-radio-group aria-label="Select an option" formControlName="dateFilterType">
        <mat-radio-button value="usage_date" (change)="dateFilterTypeChanged($event)"
          [checked]="selectedDateFilterType === 'usage_date'">Usage date</mat-radio-button>
        <mat-radio-button value="billing_date" (change)="dateFilterTypeChanged($event)">Billing date</mat-radio-button>
      </mat-radio-group>
      <!-- <div></div> -->
    </div>
    <br *ngIf="isBillingTab" />
    <!-- <mat-label class="label">You should make new date selection after switching.</mat-label>
        <br *ngIf="isBillingTab" />-->
    <div class="from-to">
      <div *ngIf="selectedDateFilterType === 'usage_date' || !isBillingTab">
        <label class="label">From</label>
        <mat-form-field appearance="fill" class="date-form-field">

          <input placeholder="Choose start date" (dateChange)="dateChanged()" [max]="today" matInput
            formControlName="startDate" [matDatepicker]="startDatepicker" />
          <mat-datepicker-toggle matPrefix [for]="startDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatepicker> </mat-datepicker>
        </mat-form-field>
      </div>

      <div *ngIf="selectedDateFilterType === 'usage_date' || !isBillingTab">
        <label class="label">To</label>
        <mat-form-field appearance="fill" class="date-form-field">
          <input placeholder="Choose end date" (dateChange)="dateChanged()" [max]="today" matInput
            formControlName="endDate" [matDatepicker]="endDatepicker" />
          <mat-datepicker-toggle matPrefix [for]="endDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatepicker> </mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="selectedDateFilterType === 'billing_date' && isBillingTab" class="month-year-date">
      <mat-form-field appearance="fill">
        <mat-label style="color: var(--dark-text)">Select Year and Month <br />{{
          monthYearDate ?? "MM/YYYY"
          }}</mat-label>
        <input matInput [max]="today" [matDatepicker]="monthYearDatePicker" formControlName="monthYearDate" />
        <!-- <mat-hint *ngIf="!monthYearDate">MM/YYYY</mat-hint> -->
        <mat-datepicker-toggle matIconSuffix [for]="monthYearDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #monthYearDatePicker startView="multi-year"
          (monthSelected)="setMonthAndYear($event, monthYearDatePicker)" panelClass="example-month-picker">
        </mat-datepicker>
      </mat-form-field>
    </div>
  </form>
  <p style="color: red; margin-left: 6rem" *ngIf="this.isDateRangeWrong">
    Start Date should be <= End Date, Please check. </p>
      <div class="separator" *ngIf="
      !showMonthsOnly &&
      ((selectedDateFilterType === 'usage_date' && isBillingTab) ||
        !isBillingTab)
    ">
        OR
      </div>

      <div class="quick-select" *ngIf="
      (selectedDateFilterType === 'usage_date' && isBillingTab) || !isBillingTab
    ">
        <span class="label">Choose Month</span>
        <div class="buttons-grid">
          <button *ngFor="let btn of btnValues; let i = index" [disabled]="disable" [class.dark]="i > 11"
            [class.selected]="activeBtn === btn.label" (click)="quickDateSelection($event, btn)" type="button"
            mat-raised-button>
            {{ btn.label }}
          </button>
        </div>
      </div>
      <!-- <mat-divider></mat-divider>
    <mat-checkbox class="compare-chbx" color="primary" (change)="chbxChanged($event)"
        (click)="$event.stopPropagation()">
        {{chbxLabel}}
    </mat-checkbox> -->
</div>